import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private authService: CalAngularService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isUserSignedIn()) {
      return true;
    } else {
      return false;
    }
  }
}
